import Cookies from 'js-cookie'

export default function () {
    //Note that we don't want to clear all cookies,
    //e.g. GA, other trackers etc.
    ['email', 'token', 'role', 'origin'].forEach(name => Cookies.remove(name));
}